import script from "./LivingPeopleModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LivingPeopleModal.vue?vue&type=script&lang=ts&setup=true"

import "./LivingPeopleModal.vue?vue&type=style&index=0&id=1a189744&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a189744"]])

export default __exports__